module.exports = __webpack_public_path__ + "static/media/84.29d2927c.jpg";